import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class SelectedPlanService {
    private selectedPlans?: LevelMoveOverride[] = [];

    public saveSelectedPlans(plans: LevelMoveOverride[]): void {
        this.selectedPlans = plans;
    }

    public getSelectedPlans(): LevelMoveOverride[] {
        return this.selectedPlans;
    }
}
